<template>
  <modal
    v-if="isOpen"
    :title="$t('DeliveryLocationModal.title')"
    :closableBackdrop="false"
    :closable="true"
    @close-request="emitClose()"
  >
    <p class="text-center red-text"><i class="fa fa-exclamation mr-1" /><i>{{$t('DeliveryLocationModal.process_tooltip')}}</i></p>
    <delivery-location-details
      ref="delivLocDetails"
      :showBilling="showBilling"
      :order="order"
      :addressbook="addressbook"
      :isFromDispatch="isFromDispatch"
      @sendSelectedEmails="updateSelectedEmails"
      @onVGAInput="onVGASearchInput"
    />
    <hr class="mx-3">
    <div class="post-content-wrapper m-2">
      <p>{{$t('DeliveryLocationModal.action_description_label')}}</p>
      <toggle-switch
        :optionList="optionList"
        :multiple="true"
        @emitOptionList="updateOptionSelect"
      />
      <p class="red-text mt-3">{{feedbackMessage}}</p>
      <button class="mt-2 mb-3 btn btn-kne-orange" @click="onSaveLocation(order)">{{$t('General.save')}}</button>
    </div>

  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import DeliveryLocationDetails from '../Other-components/DeliveryLocationDetails.vue'
import ToggleSwitch from '../Other-components/ToggleSwitch.vue'

export default {
  name: 'DeliveryLocationModal',

  components: {
    DeliveryLocationDetails,
    Modal,
    ToggleSwitch
  },

  props: {
    originalList: Object,
    addressbook: Array,
    showBilling: {
      type: Boolean,
      required: true
    },
    isFromDispatch: {
      type: Boolean,
      default: false,
      required: false
    },
    orderNumber: String, // Order object doesn't have order number sometimes, this just makes it easier to access it
    isOpen: Boolean
  },

  data () {
    return {
      order: {},
      deliverySave: false,
      pickupSave: false,
      receiverEmailList: [],
      transmitterEmailList: [],
      optionList: {
        transmitter: {
          id: 1,
          label: this.$t('DeliveryLocationModal.transmitter'),
          value: 'transmitter',
          selected: false,
          bgColor: 'rgba(255, 178, 84, 0.3)',
          selectedBgColor: 'rgb(255, 178, 84)'
        },

        receiver: {
          id: 2,
          label: this.$t('DeliveryLocationModal.receiver'),
          value: 'receiver',
          selected: false,
          bgColor: 'rgba(255, 178, 84, 0.3)',
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        }
      },
      isApplyToAllTransmitter: false, // Apply the receiver location to all selected orders
      isApplyToAllReceiver: false, // Apply the receiver location to all selected orders
      feedbackMessage: ''
    }
  },

  methods: {
    onVGASearchInput () {
      this.setFeedbackMessage('')
    },

    /** Apply a location update to all orders when dispatching */
    updateOptionSelect (selectedOption) {
      for (const key in selectedOption) {
        if (Object.hasOwnProperty.call(selectedOption, key)) {
          const option = selectedOption[key]

          if (option.id === this.optionList.transmitter.id) this.isApplyToAllTransmitter = option.selected
          if (option.id === this.optionList.receiver.id) this.isApplyToAllReceiver = option.selected
        }
      }
    },

    setOrder (originalOrder) {
      const copiedOrder = {...originalOrder}
      this.order = copiedOrder
    },

    /** From @emits 'sendSelectedEmails' @DeliveryLocationDetails */
    updateSelectedEmails (selectedEmails) {
      this.selectedContactEmails = selectedEmails
    },

    setFeedbackMessage (message) {
      this.feedbackMessage = message
    },

    /** If user wants to save the location to the addressbook */
    onSaveLocation (order) {
      if (!this.isAddressFormFilled) {
        this.setFeedbackMessage(this.$t('DeliveryLocationModal.required_fields_error'))
        return
      }

      this.$refs.delivLocDetails.saveToAddressbook(this.order)
      this.emitNewOrderLocation(order)
      this.emitClose()
    },

    emitNewOrderLocation (order) {
      this.$emit('emitNewOrderLocation', order, this.isApplyToAllTransmitter, this.isApplyToAllReceiver)
    },

    emitClose () {
      this.$emit('closeModal')
    }
  },

  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAddressFormFilled () {
      let isFormFilled = false

      if (
        this.order.transmitterName !== '' &&
        this.order.transmitterAddress !== '' &&
        this.order.transmitterPostcode !== '' &&
        this.order.transmitterCity !== '' &&
        this.order.transmitterProvince !== '' &&
        this.order.transmitterCountry !== '' &&

        this.order.receiverName !== '' &&
        this.order.receiverAddress !== '' &&
        this.order.receiverCity !== '' &&
        this.order.receiverProvince !== '' &&
        this.order.receiverCountry !== ''
      ) isFormFilled = true

      return isFormFilled
    }
  }
}
</script>

<style scoped>
  .post-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end
  }
</style>
